import React from 'react';
import './AboutPage.css';
import Navbar from './Navbar';
import BreadCrumb from './BreadCrumb';
import Footer from './Footer';
import Download from './Download';
import Newsletter from './Newsletter';
import { FaArrowRight, FaExclamationCircle, FaHandPointRight } from 'react-icons/fa';

const RefundPolicy = () => {
    return (
        <>
            <Navbar />
            <BreadCrumb />
            <div className="about-content" style={{ padding: '30px', backgroundColor: '#e7e7e7' }}>
                <section className="about-section mission">
                    <h1>Refund Policy</h1>

                    <h3>1. Introduction</h3>
                    <p className="risefx-description" style={{ marginLeft: '0' }}>
                        At RISEFX, we prioritize transparency and customer satisfaction. This Refund Policy outlines the terms under which refunds may be processed for deposits, trading losses, and other transactions. By using our services, you agree to the terms below.
                    </p>

                    <h3 style={{marginBottom: '20px'}}>2. General Refund Conditions</h3>
                    <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        2.1 Non-Refundable Transactions:
                        <h4><FaExclamationCircle style={{ color: '#e6c614', marginRight: '20px' }} />
                            Due to the nature of forex trading, all deposits made for trading purposes are non-transferable, and cannot be converted into cash withdrawals unless explicitly stated in this policy.
                        </h4>
                        <h4><FaExclamationCircle style={{ color: '#e6c614', marginRight: '20px' }} />
                            Trading losses incurred due to market fluctuations, leverage, or personal trading decisions are non-refundable.
                        </h4>
                        2.2 Eligible Refunds:
                        <h4><FaHandPointRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Refunds may be considered in the following cases:

                        </h4>
                        <h4><FaHandPointRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Unauthorized transactions due to fraud or security breaches, subject to investigation.
                        </h4>
                        <h4><FaHandPointRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Duplicate transactions made in error by the client.
                        </h4>
                        <h4><FaHandPointRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Failed deposit attempts where funds were deducted but not credited to the trading account.
                        </h4>
                        
                    </p>

                    <h3 style={{marginBottom: '20px'}}>3. Refund Request Process</h3>
                    <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <span>3.1 To request a refund, the client must:</span>
                        <h4><FaHandPointRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Submit a written request via email <a href="mailto:enquiry@therisefx.com">enquiry@therisefx.com</a> to within 7 business days of the disputed transaction.
                        </h4>
                        <h4><FaHandPointRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Provide transaction details, proof of payment, and valid reasons for the refund.
                        </h4>
                        <h4><FaHandPointRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Comply with any verification process as required by our compliance team.
                        </h4>
                        <span>
                        3.2 Refund requests will be reviewed within 10 business days, and the decision will be communicated via email. If approved, the refund will be processed through the original payment method within 7-14 business days.
                        </span>
                    </p>

                    <h3 style={{marginBottom: '20px'}}>4. Withdrawal Policy</h3>
                    <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', flexDirection: 'column', gap: '20px' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Withdrawals must be requested through the platform and require KYC verification.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Processing time for withdrawals is 12-24 hours.
                        </h4>
                       
                    </p>

                    <h3 style={{marginBottom: '20px'}}>5. Chargebacks & Disputes</h3>
                    <p className="risefx-description" style={{ marginLeft: '0', display: 'flex', flexDirection: 'column', gap: '20px' }}>

                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Chargebacks are not allowed. Users must resolve disputes directly with RiseFX.
                        </h4>
                        <h4><FaArrowRight style={{ color: '#e6c614', marginRight: '20px' }} />
                        Unauthorized chargebacks may lead to account suspension.
                        </h4>
                    
                    </p>

                </section>
            </div>
            <Download />
            <Newsletter />
            <Footer />
        </>
    );
}

export default RefundPolicy;
